import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { InputField1 } from "../InputField1/InputField1";
import Typography from "../Typography/Typography";
import { useGetEditAccessItem } from "../../hooks/useManagement";

export const EditAccessLevelModal = ({ show, handleClose, item }) => {
  const [button] = useState(false);
  const [form, setForm] = useState({});

  useEffect(() => {
    if (item) {
      setForm(item);
    }
  }, [item]);
  const { mutateAsync: edit } = useGetEditAccessItem();
  const handleEditUser = async () => {
    const user = new FormData();
    user.append("IdMonshis", form.IdMonshis);
    user.append("Phone", form.Phone);
    user.append("FirstName", form.FirstName);
    user.append("LastName", form.LastName);
    user.append("profile", form.profile);
    user.append("password", form.password);
    user.append("UnitAccounting", form.UnitAccounting);
    user.append("UnitContent", form.UnitContent);
    user.append("UnitCRM", form.UnitCRM);
    user.append("UnitManagement", form.UnitManagement);
    user.append("password", form.password);
    await edit(user).then(() => setForm({}));
  };
  console.log(form);
  return (
    <BootstrapModal
      modaltitle="ویرایش همکار"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="lg"
      closebutton={
        <Button
          style={{ width: "40px", border: "none" }}
          onclick={() => {
            handleClose();
          }}
        >
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-lg-3 col-12">
          <InputField1
            type="file"
            label="عکس پروفایل"
            onChange={(e) => setForm({ ...form, profile: e.target.files[0] })}
          />
        </div>
        <div className="col-lg-3 col-12">
          <InputField1
            placeholder="نام را وارد کنید"
            label="نام"
            onChange={(e) => setForm({ ...form, FirstName: e.target.value })}
            value={form.FirstName}
          />
        </div>
        <div className="col-lg-3 col-12">
          <InputField1
            placeholder="نام خانوادگی را وارد کنید"
            label="نام خانوادگی"
            onChange={(e) => setForm({ ...form, LastName: e.target.value })}
            value={form.LastName}
          />
        </div>
        <div className="col-lg-3 col-12">
          <InputField1
            placeholder="شماره موبایل را وارد کنید"
            label="شماره موبایل"
            onChange={(e) => setForm({ ...form, Phone: e.target.value })}
            value={form.Phone}
          />
        </div>
        <div className="col-lg-3 col-12">
          <InputField1
            placeholder="رمز عبور"
            label="رمز عبور"
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            value={form.password}
          />
        </div>
        <div className="col-12">
          <div className="row mt-3">
            <div className="col-12 mb-2">
              <Typography>دسترسی ها</Typography>
            </div>
            <div className="col-lg-3 col-12">
              <div className="border">
                <input
                  className="my-3 mx-2"
                  type="checkbox"
                  id="accounting"
                  name="accounting"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      UnitAccounting: e.target.checked ? "on" : "empty",
                    })
                  }
                  checked={form.UnitAccounting === "on" ? true : false}
                />
                <label for="accounting">واحد حسابداری</label>
              </div>
            </div>
            <div className="col-lg-3 col-12">
              <div className="border">
                <input
                  className="my-3 mx-2"
                  type="checkbox"
                  id="content"
                  name="content"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      UnitContent: e.target.checked ? "on" : "empty",
                    })
                  }
                  checked={form.UnitContent === "on" ? true : false}
                />
                <label for="content">واحد محتوا</label>
              </div>
            </div>
            <div className="col-lg-3 col-12">
              <div className="border">
                <input
                  className="my-3 mx-2"
                  type="checkbox"
                  id="crm"
                  name="crm"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      UnitCRM: e.target.checked ? "on" : "empty",
                    })
                  }
                  checked={form.UnitCRM === "on" ? true : false}
                />
                <label for="crm">واحد CRM</label>
              </div>
            </div>
            <div className="col-lg-3 col-12">
              <div className="border">
                <input
                  className="my-3 mx-2"
                  type="checkbox"
                  id="managing"
                  name="managing"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      UnitManagement: e.target.checked ? "on" : "empty",
                    })
                  }
                  checked={form.UnitManagement === "on" ? true : false}
                />
                <label for="managing">واحد مدیریت</label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-12 mt-lg-1 mt-3">
          <Button
            bgColor="#009ef7"
            small="70px"
            color="#fff"
            onclick={() => {
              handleClose();
              handleEditUser(form);
            }}
          >
            ثبت
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
